exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".react-bootstrap-table-page-btns-ul {\n  float: right;\n  margin-top: 0px !important; }\n\n.react-bootstrap-table-pagination-list-hidden {\n  display: none; }\n", ""]);

